"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valderice": {
    "dc33ba4f": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "skipSearch": false
    }],
    "capoluogo-fico-san-marco-paparella-misericordia": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f2251f7e": [{
      "hkey": "6a07ae61",
      "slug": "crocevie",
      "name": "Crocevie",
      "primary": true,
      "skipSearch": false
    }],
    "crocevia": [{
      "hkey": "6a07ae61",
      "slug": "crocevie",
      "name": "Crocevie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8a4f7567": [{
      "hkey": "eb1bf314",
      "slug": "valderice",
      "name": "Valderice",
      "primary": true,
      "skipSearch": false
    }],
    "lentina": [{
      "hkey": "eb1bf314",
      "slug": "valderice",
      "name": "Valderice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9df9ca57": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "skipSearch": false
    }],
    "misericordia": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valderice"
    }],
    "6ad83368": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "skipSearch": false
    }],
    "paparella": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valderice"
    }],
    "6eabc87d": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "a18568ed",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valderice"
    }]
  }
};
exports["default"] = _default;